import { useFormattedDate } from "@jugl-web/utils/hooks/useFormattedDate";
import { FC } from "react";
import {
  TicketDetailItem,
  TicketDetailItemText,
} from "../../../TicketDetailItem";

interface OpenedAtDetailItemProps {
  insertedAt: string;
}

export const OpenedAtDetailItem: FC<OpenedAtDetailItemProps> = ({
  insertedAt,
}) => {
  const { formatDateTimeLabel } = useFormattedDate();

  return (
    <TicketDetailItem
      label="Created at"
      content={
        <TicketDetailItemText
          text={formatDateTimeLabel(new Date(insertedAt), "concise")}
        />
      }
    />
  );
};
